var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[(!_vm.isEmpty)?[_vm._t("default")]:_vm._e(),(_vm.isEmpty)?_c('div',{staticClass:"empty-msg"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/empty.png")}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }